import React from 'react';
import { ChevronButton } from './ChevronButton';

interface Props {
  currentYear: number;
  setCurrentYear: (newYear: number) => void;
  minYear: number;
  maxYear: number;
}
export const SwitchYearButtons: React.FC<Props> = ({ currentYear, maxYear, minYear, setCurrentYear }) => {
  return (
    <div className="flex justify-center  ">
      <ChevronButton
        direction="left"
        disabled={currentYear == minYear}
        onButtonClick={() => setCurrentYear(currentYear - 1)}
      />
      <div className="text-base mb-0  flex flex-col justify-center">{currentYear}</div>
      <ChevronButton
        direction="right"
        disabled={currentYear == maxYear}
        onButtonClick={() => setCurrentYear(currentYear + 1)}
      />
    </div>
  );
};
